export default {"src":"/komodo/_next/static/media/facebook.dfdb0076.svg","height":67,"width":67,"blurWidth":0,"blurHeight":0};